export const CREATE_REQUEST_EXPENSE = "CREATE_REQUEST_EXPENSE";
export const FETCH_REQUEST_EXPENSES = "FETCH_REQUEST_EXPENSES";
export const FETCH_REQUEST_EXPENSE = "FETCH_REQUEST_EXPENSE";
export const EDIT_REQUEST_EXPENSE = "EDIT_REQUEST_EXPENSE";
export const DELETE_REQUEST_EXPENSE = "DELETE_REQUEST_EXPENSE";
